import React, { useMemo, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const API_BASE = "https://api.cloud.linkbms.eu";

export default function ResetPassword() {
  const navigate = useNavigate();
  const location = useLocation();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [infoMessage, setInfoMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const token = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return (params.get("token") || "").trim();
  }, [location.search]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage("");
    setInfoMessage("");

    if (!token) {
      setErrorMessage("Reset token is missing.");
      return;
    }

    if (newPassword.length < 8) {
      setErrorMessage("Password must be at least 8 characters long.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setErrorMessage("Passwords do not match.");
      return;
    }

    setSubmitting(true);
    try {
      const response = await fetch(`${API_BASE}/password_reset/confirm`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          token,
          new_password: newPassword,
        }),
      });

      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        setErrorMessage(data.error || "Could not reset password.");
        return;
      }

      setInfoMessage(data.message || "Password updated successfully.");
      setNewPassword("");
      setConfirmPassword("");
      setTimeout(() => navigate("/login"), 1200);
    } catch (error) {
      setErrorMessage("An error occurred. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-container">
      <form onSubmit={handleSubmit} className="login-form">
        {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
        {infoMessage && <p style={{ color: "green" }}>{infoMessage}</p>}
        <table>
          <thead>
            <tr>
              <th colSpan="2">Set New Password</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <label htmlFor="new-password">New password:</label>
              </td>
              <td>
                <input
                  type="password"
                  id="new-password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                />
              </td>
            </tr>
            <tr>
              <td>
                <label htmlFor="confirm-password">Confirm password:</label>
              </td>
              <td>
                <input
                  type="password"
                  id="confirm-password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
              </td>
            </tr>
          </tbody>
        </table>

        <br />
        <input type="submit" value={submitting ? "Saving..." : "Save new password"} disabled={submitting} />
      </form>
    </div>
  );
}
